<template>
  <div class="Admin">
    <div class="login-container">
      <div class="login-header text-center mb-6">
        <h1 class="text-3xl font-bold text-gray-900 tracking-wide">
          CISA Admin Login
        </h1>
        <p class="text-gray-600 text-sm mt-1">
          Acesse sua conta para continuar
        </p>
      </div>
      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label
            for="email"
            class="block text-gray-700 text-sm md:text-base font-medium"
          >
            E-mail
          </label>
          <input
            v-model="email"
            type="email"
            id="email"
            class="w-full p-3 mt-1 bg-gray-200 text-gray-900 rounded-lg focus:ring focus:ring-blue-300"
            placeholder="Digite seu e-mail"
            required
            aria-label="E-mail"
          />
        </div>

        <div class="mb-4 relative">
          <label
            for="password"
            class="block text-gray-700 text-sm md:text-base font-medium"
          >
            Senha
          </label>
          <div class="relative">
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              id="password"
              class="w-full p-3 mt-1 bg-gray-200 text-gray-900 rounded-lg focus:ring focus:ring-blue-300 pr-12"
              placeholder="Digite sua senha"
              required
              aria-label="Senha"
            />
            <button
              type="button"
              class="absolute right-3 transform text-gray-600 hover:text-gray-900"
              @click="togglePassword"
            >
              <svg
                v-if="!showPassword"
                class="w-5 h-5 text-gray-600"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 5C7.5 5 3.73 7.61 2 12c1.73 4.39 5.5 7 10 7s8.27-2.61 10-7c-1.73-4.39-5.5-7-10-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                  fill="currentColor"
                />
              </svg>
              <svg
                v-else
                class="w-5 h-5 text-gray-600"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 6.5c2.6 0 5.02 1.28 6.5 3.5-1.48 2.22-3.9 3.5-6.5 3.5s-5.02-1.28-6.5-3.5c1.48-2.22 3.9-3.5 6.5-3.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="flex justify-between items-center mb-4">
          <label class="flex items-center text-gray-700 text-sm md:text-base">
            <input
              v-model="rememberMe"
              type="checkbox"
              class="mr-2 accent-blue-500"
            />
            Lembrar-me
          </label>
        </div>

        <button
          type="submit"
          class="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-lg transition flex items-center justify-center gap-2"
          :disabled="loading"
        >
          <svg
            v-if="loading"
            class="animate-spin h-5 w-5 text-white"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z"
            ></path>
          </svg>
          <span>{{ loading ? 'Entrando...' : 'Entrar' }}</span>
        </button>
      </form>

      <div v-if="errorMessage" class="mt-4 text-center text-red-500">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { AdminLogin } from '@/services/auth/api.auth'
export default {
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      loading: false,
      errorMessage: '',
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errorMessage = ''

      try {
        await new Promise((resolve) => setTimeout(resolve, 2000))
        const response = await AdminLogin(this.email, this.password)
        this.$router.push('/admin/dashboard')
      } catch (error) {
        this.errorMessage = 'Falha ao fazer login. Verifique suas credenciais.'
        console.error('Erro no login:', error)
      } finally {
        this.loading = false
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    },
  },
}
</script>
<style scoped>
.Admin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #1e3a8b;
}

.login-container {
  width: 100%;
  max-width: 400px;
  background: rgb(239, 236, 236);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>
